import React, { FC } from 'react';
import CachedIcon from '@mui/icons-material/Cached';
import { Box } from '@mui/material';
import { format } from 'date-fns';
import DateUtils from '../../../utils/dateUtils';
import TwTooltip from '../../TwTooltip/TwTooltip';

interface CheckedDateTimeProps {
  date: Date;
  time: Date;
  id?: string;
  label?: string;
  overridden?: boolean;
  disableEdition?: boolean;
  shortOffset?: string;
  onEditClick?: () => void;
}

const CheckedDateTime: FC<CheckedDateTimeProps> = ({
  date,
  time,
  label,
  id,
  overridden,
  disableEdition,
  shortOffset,
  onEditClick
}) => {
  const d = format(date, 'MM/dd/yy');

  const t = DateUtils.getTime(time);

  return (
    <Box
      id={id}
      sx={{
        fontSize: '14px',
        lineHeight: '24px',
        color: '#6B7280',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap'
      }}
    >
      <Box sx={{ whiteSpace: 'nowrap', marginRight: '4px', display: 'flex', alignItems: 'center' }}>
        {label || 'Checked at:'}&nbsp;
        <span style={{ color: '#1F2937' }}>
          {`${d} • ${t}`} {shortOffset}
        </span>
      </Box>

      {overridden && (
        <TwTooltip title="Overridden" placement="top">
          <CachedIcon sx={{ fill: '#9CA3AF', fontSize: '20px', marginRight: '4px' }} />
        </TwTooltip>
      )}

      {onEditClick && !disableEdition && (
        <Box
          component="span"
          onClick={(): void => onEditClick && onEditClick()}
          sx={{
            color: '#3A4DE9',
            cursor: 'pointer'
          }}
        >
          {' '}
          Edit
        </Box>
      )}
    </Box>
  );
};

export default CheckedDateTime;
